import { Box } from "@mui/material";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { Fragment, useContext, useState } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { sentenceCase } from "../../../../constants";
import { BackIcon } from "../../../../assets/icons/icon";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const RendorList = ({ title, list = [], seeMoreLess, onClick }) => {
  const [I18n] = useContext(LanguageContext);
  const [seeMore, setSeeMore] = useState(false);
  let tempList = [...list];

  const uncategorizedItem = tempList.find(
    (item) => item?.label?.toLowerCase() === "uncategorized",
  );

  const filteredList = tempList.filter(
    (item) => item?.label?.toLowerCase() !== "uncategorized",
  );

  let visibleList =
    seeMore || !seeMoreLess ? filteredList : filteredList.slice(0, 2);

  tempList = uncategorizedItem
    ? [...visibleList, uncategorizedItem]
    : visibleList;

  return (
    <Box className={styles.listContainer}>
      <ParagraphText className={"fontSize16 fontWeight500 newLightColor"}>
        {I18n[title] || title}
      </ParagraphText>
      {tempList.length > 0 &&
        tempList.map((item, index) => (
          <Box key={index} className={styles.listUpperContainer}>
            <Box
              className={`cursorPointer d-flex align-items-center justify-content-between ${styles.listItem}`}
              onClick={() => {
                if (onClick) {
                  triggerLogEvent(analytics, "bo_pnl_item_click", { label: item.label, section: title });
                  onClick(item.label);
                }
              }}
            >
              <Box className="d-flex align-items-center">
                <ParagraphText
                  className={"fontSize16 fontWeight400 newFontColor"}
                >
                  {sentenceCase(I18n[item.label] || item.label || "")}
                </ParagraphText>
                {item?.label?.toLowerCase() == "uncategorized" ? (
                  <UBButton
                    id="profit_loss_download_btn"
                    className={`ubPrimaryButton ${styles.organizeButton}`}
                    iconPlacement="right"
                    iconComponent={<BackIcon />}
                    title={
                      title == "expenses"
                        ? I18n.organize_your_expenses
                        : I18n.organize_your_sales
                    }
                  />
                ) : null}
              </Box>

              <ParagraphText
                className={"fontSize16 fontWeight400 newFontColor"}
              >{`${(item.value || 0) < 0 ? "-" : item?.isSign ? "+" : ""}Rs. ${formatNum(Math.abs(item.value || 0))}`}</ParagraphText>
            </Box>

            {index + 1 != tempList?.length || seeMoreLess ? <hr /> : null}
          </Box>
        ))}
      {seeMoreLess && (
        <ParagraphText
          className={`fontSize14 barclayBlueColor cursorPointer ${styles.seeMoreButton}`}
          onClick={() => setSeeMore(!seeMore)}
        >
          {sentenceCase(
            `${seeMore ? I18n.see_less : I18n.see_more} ${I18n.categories}`,
          )}
        </ParagraphText>
      )}
    </Box>
  );
};
export default RendorList;
